import { Box } from '@mui/material';
import { LeftSpacer } from '../styles/LoginContainerStyle';

export const LoginLogo = () => {
  return (
    <LeftSpacer>
      <img src="/images/logopart1.png" alt="ProPlus" style={{ height: 70 }} />
      <img src="/images/logopart2.png" alt="Setting Navi" style={{ height: 250 }} />

      <Box
        sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          fontSize: 12,
          color: '#fff',
        }}
      >
        Copyright © 2026 Pro-Ship Incorporated. All rights reserved.
      </Box>
    </LeftSpacer>
  );
};
